export interface CaretSelection {
  selectionEnd: number | null;
  selectionStart: number | null;
}

export interface CursorInsertResult {
  caret: number;
  text: string;
}

/**
 * Splices `insert` into `value` at the last caret or selection. A blurred input
 * keeps its selection, so this still works after a toolbar menu took focus; with
 * no selection it appends. Returns null, leaving the text alone, when the result
 * would pass `characterLimit`: a merge tag cut short (`{{contact.fir`) is worse
 * than no insert, and `maxLength` only limits typing.
 */
export function insertAtCursor(
  value: string,
  insert: string,
  sel: CaretSelection | null,
  characterLimit?: number,
): CursorInsertResult | null {
  const start = sel?.selectionStart ?? value.length;
  const end = sel?.selectionEnd ?? value.length;
  const text = value.slice(0, start) + insert + value.slice(end);

  if (characterLimit && text.length > characterLimit) {
    return null;
  }

  return { caret: start + insert.length, text };
}
